import { type ReactNode } from 'react';
import { Paragraph, Heading } from '@hungryroot/ui-kit';
import styles from './ProductInfo.module.css';

export interface ProductInfoLabelValue {
  label: string;
  value: ReactNode;
}
interface ProductInfoProps {
  productInfo: ProductInfoLabelValue[];
  reverseLabelValue?: boolean;
}

export function ProductInfo(props: ProductInfoProps) {
  const { productInfo, reverseLabelValue } = props;
  return (
    <div className={styles.container}>
      {productInfo.map(({ label, value }) => (
        <div key={label} className={styles['product-info-item']}>
          {reverseLabelValue ? (
            <>
              <Heading variant="H6">{value}</Heading>
              <Paragraph
                variant="caption"
                className={styles['product-info-label']}
              >
                {label}
              </Paragraph>
            </>
          ) : (
            <>
              <Paragraph
                variant="caption"
                className={styles['product-info-label']}
              >
                {label}
              </Paragraph>
              <Paragraph>{value}</Paragraph>
            </>
          )}
        </div>
      ))}
    </div>
  );
}
